<template>
    <div class="row">
        <div class="col-12">
            <card>
                <div class="d-flex justify-content-between align-items-center">
                    Registration Types
                    <router-link
                        v-if="user.admin || (event.adminRoles && event.adminRoles[user._id] && event.adminRoles[user._id].createRegistrationTypes)"
                        :to="{ name: 'registration-types-create' }">
                            <el-button
                                type="primary"
                                class="btn btn-primary">
                                    + New
                            </el-button>
                    </router-link>
                </div>
                <el-table :data="types" class="header-background" stripe border>
                    <el-table-column
                        label="Name"
                        prop="name"/>
                    <el-table-column
                        label="Actions"
                        :width="300">
                        <template slot-scope="props">
                            <div v-loading="props.row.loading" :data-loading="props.row.loading" class="loader">
                                <router-link
                                    v-if="user.admin || (event.adminRoles && event.adminRoles[user._id] && event.adminRoles[user._id].editRegistrationTypes)"
                                    :to="{ name: 'registration-types-edit', params: { typeId: props.row._id } }">
                                        <el-tooltip content="Edit" placement="top">
                                            <el-button class="btn" title="Edit">
                                                <fa :icon="['fas', 'pen']"/>
                                            </el-button>
                                        </el-tooltip>
                                </router-link>
                                <el-tooltip content="Delete" placement="top">    
                                    <el-button
                                        @click="remove(props.row._id)"
                                        class="btn btn-danger ml-1"
                                        title="Delete">
                                            <fa :icon="['fas', 'trash']"/>
                                    </el-button>
                                </el-tooltip>
                                <el-dropdown
                                    trigger="click"
                                    @command="performAction"
                                    style="position: relative; top: 2px">
                                        <span class="el-dropdown-link ml-1">
                                            <el-tooltip content="More" placement="top">
                                                <el-button title="More">
                                                    <fa :icon="['fas', 'ellipsis-v']"/>
                                                </el-button>
                                            </el-tooltip>
                                        </span>
                                        <el-dropdown-menu slot="dropdown">
                                            <el-dropdown-item :command="`clone-${props.$index}`">Clone</el-dropdown-item>
                                        </el-dropdown-menu>
                                </el-dropdown>
                            </div>
                        </template>
                    </el-table-column>
                    <el-table-column
                        :width="300"
                        label="Order"
                        prop="order">

                        <template slot-scope="props">
                            <el-input v-model="props.row.order" type="number" />
                        </template>

                    </el-table-column>
                </el-table>

                <div class="d-flex justify-content-end" >
                    <el-button
                        @click="updateTypesOrder"
                        type="primary"
                        class="btn btn-primary">
                            Save
                    </el-button>
                </div>
            </card>
        </div>

        <el-dialog
            title="Type is used!"
            :visible.sync="usedDialog">
                <h3>Attendees</h3>
                <el-table :data="attendees">
                    <el-table-column label="Name">
                        <template slot-scope="props">
                            {{ props.row | attendeeName }}
                        </template>
                    </el-table-column>
                    <el-table-column label="Actions">
                        <template slot-scope="props">
                            <router-link :to="{ name: 'attendee', params: { registrationId: props.row._id } }">
                                <el-button>
                                    Details
                                </el-button>
                            </router-link>
                        </template>
                    </el-table-column>
                </el-table>
                <h3 class="mt-4">Type Groups</h3>
                <el-table :data="registrationGroups">
                    <el-table-column label="Name" prop="name"/>
                    <el-table-column label="Actions">
                        <template slot-scope="props">
                            <router-link :to="{ name: 'registration-type-groups-edit', params: { typeGroupId: props.row._id } }">
                                <el-button class="btn">
                                    <fa :icon="['fas', 'pen']"/>
                                </el-button>
                            </router-link>
                        </template>
                    </el-table-column>
                </el-table>
        </el-dialog>
    </div>
</template>

<script>
import swal from 'sweetalert2'
import { mapState } from 'vuex'
import http from '../../http.js'

export default {
    data () {
        return {
            loading: false,
            usedDialog: false,
            attendees: [],
            registrationGroups: [],
            types: []
        }
    },
    computed: {
        ...mapState([
            'user',
            'event'
        ])
    },
    mounted () {
        this.getTypes()
    },
    methods: {
        async updateTypesOrder(){
            let arr = {}
            this.types.forEach(t => {
                if(t.order) arr[t._id] = t.order
            })

            try {
                const response = await http.post(`/api/types/update-order`, { eventId: this.$route.params.eventId, orders: arr })
                this.$notify(response.data.message)
            } catch (e) {
                console.log(e)
                this.$store.dispatch('handleErrors', e)
            }

        },
        getTypes: async function () {
            this.loading = true
            try {
                const response = await this.$store.dispatch('getAll', {
                    path: 'types',
                    params: {
                        filters: {
                            eventId: this.$route.params.eventId
                        }
                    }
                })
                this.types = response.data.types
            } catch (e) {
                console.log('erorr types', e)
            }
            this.loading = false
        },
        remove: async function (id) {
            try {
                let { value: confirmed } = await swal({
                    title: `Are you sure you want to delete this regisration type?`,
                    buttonsStyling: false,
                    showCancelButton: true,
                    confirmButtonText: 'OK',
                    cancelButtonText: 'Cancel',
                    confirmButtonClass: 'btn btn-success btn-fill',
                    cancelButtonClass: 'btn btn-default btn-fill'
                })

                if (!confirmed) {
                    return
                }

                const response = await this.$store.dispatch('remove', { path: 'types', id })

                if (response.data.attendees && response.data.registrationGroups) {
                    this.$notify({ type: 'danger', message: 'Type is being used!' })
                    this.usedDialog = true
                    this.attendees = response.data.attendees
                    this.registrationGroups = response.data.registrationGroups
                } else {
                    this.types = this.types.filter(type => type._id !== id)
                }
            } catch (e) {
                console.log(e)
                console.log('error deleting type')
            }
        },
        performAction: function (command) {
            command = command.split('-')
            const type = this.types[command[1]]

            switch (command[0]) {
                case 'clone':
                    this.clone(command[1], type._id)
                    break
            }
        },
        clone: async function (index, id) {
            this.$set(this.types[index], 'loading', true)
            try {
                const response = await http.post(`/api/types/${id}/clone`)
                this.types.push(response.data.type)
            } catch (e) {
                console.log(e)
                console.log('error clonning type')
                this.$store.dispatch('handleErrors', e)
            }
            this.$set(this.types[index], 'loading', false)
        }
    },
    filters: {
        attendeeName: (registration) => {
            let name = ''
            const firstName = registration.fields.find(field => field.fieldMapping === 'firstName')
            const lastName = registration.fields.find(field => field.fieldMapping === 'lastName')

            if (firstName) {
                name += firstName.value
            }

            if (lastName) {
                if (firstName) {
                    name += ' '
                }

                name += lastName.value
            }

            return name
        }
    }
}
</script>

<style lang="sass">

</style>